module.exports = __webpack_public_path__ + "static/media/llanta-medicion-mm-rojo.81948998.svg";